import { Address } from 'viem';

import { api, cacheTags } from 'modules/api';
import { getPublicClient } from 'modules/api/getPublicClient';

import { getPool } from '../methods/getPool';
import { IPool } from '../types';

interface IGetPoolArgs {
  address: Address;
}

export const {
  useGetPoolQuery,
  endpoints: { getPool: getPoolEndpoint },
} = api.injectEndpoints({
  endpoints: build => ({
    getPool: build.query<IPool | null, IGetPoolArgs>({
      queryFn: async ({ address }) => {
        try {
          const bffClient = getPublicClient();

          return { data: await getPool(bffClient, address) };
        } catch {
          const client = getPublicClient();

          return { data: await getPool(client, address) };
        }
      },
      providesTags: [cacheTags.pools],
    }),
  }),
});
